import { AVAILABILITY_STATUS, type AvailabilityStatus } from '../entities/property/property'

/**
 * Política de disponibilidad del inmueble (lógica pura, compartida front/back).
 * Un inmueble reservado o pendiente de autorización está bloqueado para nuevas
 * negociaciones; la excepción "la reserva es del propio asesor" se resuelve en
 * la query del backend con las reservas del usuario.
 */
export const BLOCKED_AVAILABILITY_STATUSES = [
  AVAILABILITY_STATUS.RESERVED,
  AVAILABILITY_STATUS.PENDING_AUTHORIZATION
] as const satisfies readonly AvailabilityStatus[]

export const isBlockedAvailabilityStatus = (status: AvailabilityStatus): boolean =>
  (BLOCKED_AVAILABILITY_STATUSES as readonly AvailabilityStatus[]).includes(status)

export const canEnterNegotiation = (property: {
  active: boolean
  inNegotiation: boolean
  availabilityStatus: AvailabilityStatus
}): boolean =>
  property.active &&
  !property.inNegotiation &&
  !isBlockedAvailabilityStatus(property.availabilityStatus)
